export const targetedAreas = [
  "التجمع الخامس",
  "التجمع الاول",
  "التجمع الثالث",
  "مدينة نصر",
  "القطامية",
  "زهراء المعادي",
  "المعادي",
  "صقر قريش",
  "مصر الجديدة",
  "السلام",
  "شيراتون",
  "النزهة",
  "العباسية",
  "مدينتي",
  "الرحاب",
  "العبور",
  "المقطم",
  "العاصمة الإدارية",
  "أكتوبر",
  "الشيخ زايد",
  "اسكندرية",
  "الساحل الشمالي",
  "طريق السخنة",
  "طريق السويس"
];
